// src/components/CustomAccordion.tsx
import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';

const StyledAccordion = styled(Accordion, {
  shouldForwardProp: (props) => props !== 'accordionVariant',
})<{
  accordionVariant?: 'default' | 'medium' | 'small';
}>(({ theme, accordionVariant }) => ({
  width: '100%',
  boxShadow: 'none',
  '&:before': {
    display: 'none',
  },
  ...(accordionVariant === 'medium' && {
    padding: theme.spacing(0),
  }),
}));

const StyledAccordionSummary = styled(AccordionSummary)<{
  variant?: 'default' | 'medium' | 'small';
}>(({ theme, variant }) => ({
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper': {
    marginRight: theme.spacing(2),
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: 0,
  },
  ...((variant === 'medium' || variant === 'small') && {
    background: 'none !important',
    '&.MuiAccordionSummary-root': {
      padding: 0,
      minHeight: '48px',
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      transform: 'rotate(-90deg)',
      '&.Mui-expanded': {
        transform: 'rotate(0)',
      },
    },
    // '&.MuiAccordionSummary-root': {
    //   minHeight: '48px',
    // },
    '& .MuiAccordionSummary-content': {
      margin: theme.spacing(1.5, 0), //'12px 0',
    },
  }),
  ...(variant === 'small' && {
    '&.MuiAccordionSummary-root': {
      padding: 0,
      height: '0px',
      minHeight: '32px',
    },
    '& .MuiAccordionSummary-content': {
      margin: theme.spacing(0), //'12px 0',
    },
  }),
}));

const StyledAccordionSDetails = styled(AccordionDetails)<{
  variant?: 'default' | 'medium' | 'small';
}>(({ theme, variant }) => ({
  ...(variant === 'medium' && {
    '&.MuiAccordionDetails-root': {
      padding: theme.spacing(1, 1.5),
    },
  }),
}));

const StyledTypography = styled(Typography)(({ theme: _theme }) => ({
  fontWeight: 'bold',
  fontSize: '1.2rem',
}));

interface CustomAccordionProps {
  title: React.ReactNode;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  variant?: 'default' | 'medium' | 'small' | undefined;
}

const CustomAccordion: React.FC<CustomAccordionProps> = ({
  title,
  children,
  defaultExpanded = true,
  variant = 'default',
}) => {
  const boxSx =
    variant === 'default' ? { pl: 1, pr: 4, pt: 2, pb: 0 } : { p: 0 };
  return (
    <StyledAccordion
      accordionVariant={variant}
      defaultExpanded={defaultExpanded}
    >
      <StyledAccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${title}-content`}
        id={`${title}-header`}
        variant={variant}
      >
        {'string' === typeof title ? (
          <StyledTypography>{title}</StyledTypography>
        ) : (
          title
        )}
      </StyledAccordionSummary>
      <StyledAccordionSDetails variant={variant}>
        <Box sx={boxSx}>{children}</Box>
      </StyledAccordionSDetails>
    </StyledAccordion>
  );
};

export default CustomAccordion;
